(function () {
  var TOGGLE = '.product__media-toggle';
  var LIST = '.product__media-list, .product-media-modal__content';
  var MODAL = '.product-media-modal__content';
  var THRESHOLD = 6;

  var el = null, pid = null, startX = 0, startLeft = 0, moved = 0, active = false;

  function onDown(e) {
    if (e.pointerType === 'touch') return;
    if (e.button !== undefined && e.button !== 0) return;
    var list = e.target.closest ? e.target.closest(LIST) : null;
    if (!list || list.scrollWidth <= list.clientWidth + 2) return;
    el = list;
    pid = e.pointerId;
    startX = e.clientX;
    startLeft = list.scrollLeft;
    moved = 0;
    active = false;
  }

  function onMove(e) {
    if (!el || e.pointerId !== pid) return;
    var d = e.clientX - startX;
    if (Math.abs(d) > moved) moved = Math.abs(d);
    if (!active) {
      if (moved < THRESHOLD) return;
      active = true;
      el.style.scrollSnapType = 'none';
      el.style.scrollBehavior = 'auto';
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';
      try { el.setPointerCapture(pid); } catch (err) {}
    }
    e.preventDefault();
    el.scrollLeft = startLeft - d;
  }

  function onUp() {
    if (!el) return;
    if (active) {
      try { el.releasePointerCapture(pid); } catch (err) {}
      el.style.scrollSnapType = '';
      el.style.scrollBehavior = '';
      el.style.cursor = '';
      el.style.userSelect = '';
    }
    el = null;
    pid = null;
    active = false;
    setTimeout(function () { moved = 0; }, 0);
  }

  document.addEventListener('pointerdown', onDown, true);
  document.addEventListener('pointermove', onMove, true);
  window.addEventListener('pointerup', onUp, true);
  window.addEventListener('pointercancel', onUp, true);

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest(LIST)) e.preventDefault();
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest(TOGGLE)) return;
    if (moved > THRESHOLD) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      moved = 0;
    }
  }, true);

  function modalStep(dir) {
    var box = document.querySelector(MODAL);
    if (!box) return;
    var first = box.firstElementChild;
    var w = first ? first.offsetWidth : box.clientWidth;
    box.scrollBy({ left: dir * w, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-modal-prev]')) { e.preventDefault(); modalStep(-1); }
    else if (e.target.closest('[data-modal-next]')) { e.preventDefault(); modalStep(1); }
  });
})();
